import { motion } from 'framer-motion';
import { FaCheck } from 'react-icons/fa';
import { images } from '../../utils/images';

const Access = () => {
  const features = [
    "No Document Required",
    "Fully and truly decentralized platform",
    "Totally ownership free"
  ];

  return (
    <div className="bg-secondary py-20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl font-bold text-white mb-6">
              SEAMLESS AND SMOOTH ACCESS
            </h2>
            <p className="text-gray-300 mb-8">
              Experience effortless access to Mo<span className="text-primary">bnb</span>, a dynamic community-building platform where innovation meets simplicity. Our platform ensures a smooth, intuitive journey, making it easier than ever to connect, grow and thrive within a supportive community dedicated to your success.
            </p>
            <ul className="space-y-4">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center text-gray-300">
                  <FaCheck className="text-primary mr-3" />
                  {feature}
                </li>
              ))}
            </ul>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="relative h-[400px] rounded-lg overflow-hidden shadow-xl"
          >
            <img 
              src={images.access} 
              alt="Platform access" 
              className="absolute inset-0 w-full h-full object-cover"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Access;